import i18next from 'i18next';

i18next.addResources('es_CL', 'HIWLoyalty', {
  howItWorks: '¿Cómo funciona Papa Puntos?',
  isTooEasy: '¡Es muy fácil!',
  buyFavs: 'Compra tus productos favoritos de siempre.',
  explanation: 'Por cada $1.000 en compras que realices ganarás 1 Papa Punto.',
  changePoints: 'Canjea tus puntos por productos y beneficios exclusivos según tu nivel y progreso.'
});
